<template>
  <Popup @hide-popup="click">
    <section class="modal-body z1 max-width-4 white-bg p2" style="max-height: 90vh; overflow-y: auto;">
      <div class="mx3">
        <div class="flex justify-end pointer" @click="click">
          <button class="close-button">
            ×
          </button>
        </div>
        <h2 class="class bold">CONDITIONS GÉNÉRALES DE RÉSERVATION</h2>

        <section>
          <h5 class="bold">Le rôle du capitaine</h5>

          <p>Tu lances la partie en réservant un créneau.</p>

          <ul>
            <li>Tu es responsable du paiement si la partie est annulée tardivement ou s'il manque des joueurs.</li>

            <li>
              Tu peux :
              <ul>
                <li>Annuler gratuitement jusqu'à 48h avant la partie.</li>
                <li>Te retirer sans frais (sans annuler la partie) jusqu'à 48h avant, à condition qu'au moins un joueur reste inscrit.</li>
                <li>Annuler complètement dans les 48h, mais tu restes redevable du paiement total.</li>
              </ul>
            </li>

            <li>Si tu n'as pas assez de joueurs, tu peux ouvrir ta partie : elle devient accessible à tous. D'autres sportifs UCPA pourront rejoindre ton match.</li>
          </ul>
        </section>

        <section>
          <h5 class="bold">Le rôle du joueur</h5>

          <ul>
            <li>Tu t'inscris à la partie via le lien du capitaine.</li>
            <li>Tu es engagé dès ton inscription.</li>

            <li>
              Tu peux :
              <ul>
                <li>Annuler gratuitement jusqu'à 48h avant le match.</li>
                <li>Si tu te désistes moins de 48h avant le match, tu restes redevable de ta part.</li>
              </ul>
            </li>

            <li>Ton paiement est prélevé automatiquement à l'heure du match via le moyen de paiement que tu as renseigné.</li>
          </ul>

          <p>Ta seule mission: être là au top de ta forme (ou prévenir à temps !)</p>
        </section>

        <section>
          <h5 class="bold">Paiement & facturation</h5>

          <ul>
            <li>Le paiement est déclenché automatiquement à l'heure du match, via les moyens de paiement renseignés.</li>
            <li>S'il manque des participants, le capitaine couvre la différence.</li>
            <li>La facture est éditée 15 minutes après le début de la partie.</li>
          </ul>
        </section>

        <section>
          <h5 class="bold">En résumé</h5>

          <ul>
            <li>Capitaine = responsable de la réservation et du paiement.</li>
            <li>Joueur = engagé dès inscription</li>
            <li>48h avant le match, tout est encore modifiable</li>
            <li>Moins de 48h avant le match, l'engagement est ferme.</li>
          </ul>
        </section>

        <section>
          <h5 class="bold">Pourquoi ce fonctionnement?</h5>

          <p>
            À l'UCPA, on adore quand ça joue. Mais trop
            souvent, des terrains réservés restaient vides.
            Des équipes fantômes, des matchs jamais
            lancés... Résultat ? Des créneaux bloqués pour
            rien, et d'autres joueurs frustrés de ne pas
            pouvoir jouer.
            C'est pourquoi nous avons mis en place ce
            système de réservation, basé sur la confiance,
            l'engagement et un capitaine responsable.
            Jouons collectif !
          </p>
        </section>

        <Button
          class="col-12 pointer"
          :action="() => click()"
          color="violet-bg"
          text="Fermer"
        />
      </div>
    </section>
  </Popup>
</template>

<script setup>
import Popup from '@/components/elements/Popup.vue';
import Button from '@/components/elements/Button.vue';

const emit = defineEmits(['hide-popup']);

const click = () => {
  emit('hide-popup');
};

</script>

<style scoped>

.close-button {
  background: var(--violet);
  border: none;
  color: var(--white);
  font-size: 1.5rem;
  font-weight: bold;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
}
</style>
